import { render, staticRenderFns } from "./SubscriptionPrice.vue?vue&type=template&id=8648e3fc&"
import script from "./SubscriptionPrice.vue?vue&type=script&lang=js&"
export * from "./SubscriptionPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports